/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {HISTORY, Solution} from '@exc/core/src/models/Solution';

const experienceManager: Solution = {
  appId: 'experienceManagerUI',
  distributionList: ['Grp-ExCelerate-BLR'],
  path: '/experiencemanager',
  spaAppId: 'experience-platform-self-service-ui-landing',
  sandbox: {
    history: HISTORY.HISTORY,
    sources: {
      dev: 'https://localhost.corp.adobe.com:8089'
    }
  },
  access: {
    code: ['dma_aem_ams', 'dma_scene7', 'dma_mpod', 'dma_aem_cloud', 'dma_aem_onprem'],
    flag: 'aem-on-prem-enabled'
  }
};

export default experienceManager;
